import { useI18n } from '~/app/i18n/i18n';
import { useConfigurator } from '~/graphql/hooks/use-configurator';
import { useModelTechnicalDataQuery } from '~/graphql/hooks/use-configured-car-queries';

export function PrepareStockCarPriceFootnote(): string | undefined {
	const { carIdentifier } = useConfigurator();
	const technicalData = useModelTechnicalDataQuery(carIdentifier);
	const { i18n } = useI18n();
	const vehicleType = technicalData.data?.configuredCar.carlineStructureCarline?.vehicleType;

	if (vehicleType === undefined) {
		return undefined;
	}

	if (vehicleType === 'BEV') {
		return i18n('ngc.stockcar.matches.price.legalBEV');
	}
	return i18n('ngc.stockcar.matches.price.legalICE');
}
